import { useQuery } from 'react-query'
import { PaginatedRequest } from '../../core/interfaces'
import { getBusinessUnits } from '../general'

export default function useBusinessUnits(query: PaginatedRequest<any>) {
  const { data, error, isLoading } = useQuery(['businessUnits', query], () =>
    getBusinessUnits(query)
  )
  return { data, error, isLoading }
}
